import { render, staticRenderFns } from "./FreightBillTax.vue?vue&type=template&id=439ef7c5&scoped=true"
import script from "./FreightBillTax.vue?vue&type=script&lang=js"
export * from "./FreightBillTax.vue?vue&type=script&lang=js"
import style0 from "./FreightBillTax.vue?vue&type=style&index=0&id=439ef7c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439ef7c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('439ef7c5')) {
      api.createRecord('439ef7c5', component.options)
    } else {
      api.reload('439ef7c5', component.options)
    }
    module.hot.accept("./FreightBillTax.vue?vue&type=template&id=439ef7c5&scoped=true", function () {
      api.rerender('439ef7c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FreightBillTax.vue"
export default component.exports